module.exports = __webpack_public_path__ + "img/yucatan.7fe18341.jpg";